module.exports = __webpack_public_path__ + "static/media/bu_nur_temp.6b2d73a4.png";